/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Tag, Timeline } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import { useEffect, useState } from 'react';
import MyTaskService from '../../../services/MyTask.service';

export default function HistoryDrawer({
    isChangeStatus,
    setIsChangeStatus,
    stateName,
}) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { dsrTaskId } = useParams();

    let lang = i18n.language;

    const _getTagRequest = (nameEn, nameTh) => {
        if (nameEn === 'New') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Verified') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#7B67FB', borderColor: '#7B67FB' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Assigned') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Preparing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'In Progress') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Reject') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const _getTagOperationStatus = (nameEn, nameTh) => {
        if (nameEn === 'Doing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Canceled') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Canceling') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'To Do') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const _getStateName = (state) => {
        switch (state) {
            case 'Verification':
                return 'verification';
            case 'Assign Task':
                return 'assignment';
            case 'Complete Task':
                return 'complete';
            case 'Other Task':
                return 'other-task';
            case 'Cancel Task':
                return 'cancel-task';
            default:
                return 'other-task';
        }
    };

    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getHistory = async (params) => {
        setLoading(true);
        try {
            setTimeout(async () => {
                const { data } = await MyTaskService.getHistories(params);
                if (data?.resultData) {
                    if (params.p === 1) {
                        setHistories(data.resultData?.result);
                        setPage(2);
                    } else {
                        const history = histories.concat(
                            data.resultData?.result
                        );
                        setHistories(history);
                        setPage(page + 1);
                    }
                    setTotal(data?.resultData?.total);
                    setLoading(false);
                }
            }, 1000);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (isChangeStatus) {
            const params = {
                dsrTaskId: dsrTaskId,
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            setHistories([]);
            getHistory(params);
            setIsChangeStatus(false);
        }
    }, [isChangeStatus]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            const params = {
                dsrTaskId: dsrTaskId,
                p: page,
                ps: 10,
                sd: 'DESC',
            };
            getHistory(params);
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories.length > 0 ? (
                        histories.map((item, i) => (
                            <Timeline.Item
                                key={item.historyId}
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                            >
                                <button
                                    className={classNames(
                                        'bg-[#EDEEF9] p-2 rounded-lg space-y-2 cursor-pointer hover:opacity-90 w-full text-left',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                    onClick={() =>
                                        navigate(
                                            `${
                                                ROUTER.DS_360.MY_TASK
                                            }/${_getStateName(stateName)}/${
                                                item?.historyId
                                            }/history`
                                        )
                                    }
                                >
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('LogDate')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.logDate
                                                ? moment(item?.logDate).format(
                                                      'DD/MM/YYYY HH:mm'
                                                  )
                                                : '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Update By')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.updateBy || '-'}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Department')} :
                                        </div>
                                        <div className="col-span-2">
                                            {item?.departmentName || '-'}
                                            {/* {lang === "en" ? item.departmentNameEn || "-" : item.departmentNameTh || "-"} */}
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Request Status')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>
                                                {_getTagRequest(
                                                    item?.requestStatus,
                                                    item?.requestStatus
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Operation Status')} :
                                        </div>
                                        <div className="col-span-2">
                                            <span>
                                                {_getTagOperationStatus(
                                                    item?.operationStatus,
                                                    item?.operationStatus
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('Note')} :
                                        </div>
                                        <div className="col-span-2 whitespace-pre-line">
                                            {item?.note || '-'}
                                        </div>
                                    </div>
                                </button>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
